export class DeliveryDate {
  date?: string;
  customer?: string;
  contract?: number;
}
